import { createThinkingFrames, createThoughtDotFrames } from "../../core/personality-keyframes.js";

export const meta = Object.freeze({
  id: "thinking",
  label: "Nachdenken",
  duration: 3000,
  description: "Blick nach oben, eine angehobene Braue und eine kleine Gedankenblase.",
  tags: ["expression", "reaction", "idle", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  if (!scene?.thoughtBubble || scene.thoughtDots.length !== 3) {
    throw new Error("Die Nachdenken-Sequenz benötigt die Gedankenblase der Stage.");
  }
  const frames = createThinkingFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.brows, frames.brows, options),
    animate(elements.browLeft, frames.browLeft, options),
    animate(elements.browRight, frames.browRight, options),
    animate(elements.mouthFlat, frames.mouth, options),
    animate(scene.thoughtBubble, frames.thoughtBubble, options),
    ...scene.thoughtDots.map((dot, index) => animate(dot, createThoughtDotFrames(index), options)),
  ];
  await Promise.allSettled(animations.map(({ finished }) => finished));
}
